import { render } from "./GroupAddMemberModal.vue?vue&type=template&id=643728a5&scoped=true&ts=true"
import script from "./GroupAddMemberModal.vue?vue&type=script&lang=ts"
export * from "./GroupAddMemberModal.vue?vue&type=script&lang=ts"

import "./GroupAddMemberModal.vue?vue&type=style&index=0&id=643728a5&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643728a5"]])

export default __exports__